import type { GetSessionV2Response } from "@endavaaccorplus/payments-common/schemas";

export const isGiftRedemptionSession = (session: GetSessionV2Response) =>
  session.type === "register-partner" &&
  session.checkoutUrl.pathname.startsWith("/product/redeem-gift");
